import React from 'react'

const EmailMarked = () => {
  return (
    <div>Favorite</div>
  )
}

export default EmailMarked